import styled from 'styled-components';
import Menu from '@mui/material/Menu';
import AppCSS from '../../utils/styled';
import { MENU_ITEM_HEIGHT, MENU_MAX_HEIGHT } from '../../utils/styled/dimensions';
import MenuItem from '@mui/material/MenuItem';

export const Components = {
  Menu: styled(Menu)`
    & .MuiPaper-root {
      overflow-x: hidden;
      overflow-y: auto;
      border-radius: 0;
      max-height: ${MENU_MAX_HEIGHT}px;
      ${AppCSS.boxShadows.menu};
      & .MuiList-root {
        padding: 0;
      }
      & .MuiMenuItem-root {
        ${AppCSS.fonts.label12Regular} !important;
        color: ${AppCSS.colors.black};
        padding: 12px !important;
        max-height: ${MENU_ITEM_HEIGHT}px;
        min-width: 145px;
        border-bottom: 1px solid ${AppCSS.colors.greys.light};
        &:hover {
          background-color: ${AppCSS.colors.utility.headerBar};
        }
      }
      & .MuiMenuItem-root:last-child {
        border-bottom: 0;
      }
    }
  `,
  // TODO - fix the styling of the menu
  InfoMenuItem: styled(MenuItem)`
    padding: 4px 12px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.light};
    max-height: ${MENU_ITEM_HEIGHT}px;
    min-width: 145px;
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    opacity: 1 !important;
    &:hover {
      background-color: ${AppCSS.colors.utility.headerBar.background};
    }
  `,
  MenuItem: styled(MenuItem)`
    ${AppCSS.fonts.label12Regular} !important;
    color: ${AppCSS.colors.black};
    padding: 12px !important;
    max-height: ${MENU_ITEM_HEIGHT}px;
    min-width: 145px;
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    &:hover {
      background-color: ${AppCSS.colors.utility.headerBar.background};
    }
  `,
  AlternativeMenuItem: styled(MenuItem)`
    color: ${AppCSS.colors.orange} !important;
    ${AppCSS.fonts.label12Regular};
    padding: 12px;
    max-height: ${MENU_ITEM_HEIGHT}px;
    min-width: 145px;
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    &:hover {
      background-color: ${AppCSS.colors.utility.headerBar.background};
    }
  `,
  DestructiveMenuItem: styled(MenuItem)`
    color: ${AppCSS.colors.red} !important;
    ${AppCSS.fonts.label12Regular};
    padding: 12px;
    max-height: ${MENU_ITEM_HEIGHT}px;
    min-width: 145px;
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    &:hover {
      background-color: ${AppCSS.colors.utility.headerBar.background};
    }
  `,
};
